/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';

export const ColStyled = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      display: flex;
      justify-content: center;
      align-items: center;
      padding: ${mediumUp ? `0 ${rem(20)} ${rem(40)}` : `0 ${rem(10)} ${rem(32)}`};
    `;
  }}
`;
